<template>
  <layout-auth>
    <v-toolbar flat color="grey lighten-3" height="50px">
      <v-container>
        <a
          class="sub-nav"
          style="font-weight: bold; color: #222222 !important"
          >{{ $t("accounts.management") }}</a
        >
        <a @click="goToAddAccount()" class="sub-nav">
          {{ $t("accounts.addAccount") }}</a
        >
      </v-container>
    </v-toolbar>
    <v-container class="py-10">
      <v-row>
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("accounts.accountNumbers") }}
          </h1>
          <p>{{ $t("accounts.listAcountManeger") }}</p>
        </v-col>
        <v-col>
          <v-btn
            @click="goToAddAccount()"
            depressed
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end my-5"
          >
            {{ $t("accounts.newAccount") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row style="align-items: center">
        <v-col sm="8">
          <h1 class="text-h5 font-weight-light">
            {{ $t("accounts.list") }}
          </h1>
        </v-col>

        <v-col sm="4">
          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="downloadExcel"
            class="float-end m-2"
          >
            <v-icon left> mdi-microsoft-excel </v-icon>
            Excel
          </v-btn>
          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="print"
            class="float-end m-2"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("supplierData.print") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="pb-10">
        <v-col cols="12">
          <v-divider
            :hidden="!noData"
            :color="entityConfig.primaryColor"
          ></v-divider>
          <error-table :erroCode="valCode" :hidden="!noData" />

          <v-data-table
            :hidden="noData"
            fixed-header
            no-data-text="No hay datos que mostrar"
            class="firt-col-right-margin"
            :headers="headers"
            :items-per-page="itemsPerPage"
            :items="accountsList"
            hide-default-footer
          >
            <template v-slot:item.iban="{ item }">
              {{ dataFormatter.accountNumberFormatter(item.iban) }}
            </template>
            <template v-slot:item.codEcvEgc="{ item }">
              {{ traducirEstadoCuenta(item.codEcvEgc) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                :color="entityConfig.primaryColor"
                class="ml-4 float-end"
                @click="deleteItem(item)"
              >
                mdi-delete-outline
              </v-icon>
              <v-icon
                :hidden="item.codEcvEgc === '1'"
                :color="entityConfig.primaryColor"
                class="ml-4 float-end"
                @click="editAcconut(item)"
              >
                mdi-pencil-outline
              </v-icon>
            </template>
          </v-data-table>
          <v-container>
            <div class="text-right" :hidden="noData">
              <v-row>
                <v-col>
                  <paginator
                    :hasPrev="hasPrev"
                    :hasNext="hasNext"
                    :pageNumber="pageNumber"
                    @pageone="goToPageOne()"
                    @prev="prevPage()"
                    @next="nextPage()"
                  ></paginator>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <account-edit-dialog
        :account="currentAccount"
        :visible="editDialog"
        @closed="editDialog = !editDialog"
      ></account-edit-dialog>
      <account-delete-dialog
        :account="currentAccount"
        :visible="deleteDialog"
        @closed="confirmDelete"
      ></account-delete-dialog>
      <overlay :visible="spinner" :opacity="1"></overlay>
    </v-container>
  </layout-auth>
</template>

<script>
import Paginator from "../../components/layouts/paginator.vue";
import Overlay from "../../components/layouts/overlay.vue";
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import AccountEditDialog from "./edit_dialog.vue";
import AccountDeleteDialog from "./delete_dialog.vue";
import Api from "../../Services/index";
import xlsx from "json-as-xlsx";
import dataFormatter from "../../plugins/dataFormatter";
import ErrorTable from "../../components/layouts/error-table.vue";

export default {
  components: {
    AccountEditDialog,
    AccountDeleteDialog,
    LayoutAuth,
    Overlay,
    Paginator,
    ErrorTable,
  },
  data() {
    return {
      noData: false,
      valCode: 0,
      query: {},
      hasNext: false,
      paginationIndex: 0,
      itemsPerPage: 0,
      pageIndexItems: [],
      dataFormatter: dataFormatter,
      userId: "",
      userdata: {},
      spinner: false,
      currentAccount: {},
      editDialog: false,
      deleteDialog: false,
      headers: [
        {
          text: "Cuenta",
          sortable: false,
          width: "16em",
          value: "iban",
        },
        {
          text: "BIC",
          sortable: false,
          value: "bic",
        },
        {
          text: "Descripción",
          sortable: false,
          value: "description",
        },
        {
          text: "Estado de Cuenta",
          sortable: false,
          value: "codEcvEgc",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
          width: "10em",
        },
      ],
      entityConfig: {},

      accountsList: [],
      accounts: [
        {
          iban: "",
          description: "",
        },
      ],
    };
  },

  async mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");

    await this.get_list_account();
  },

  computed: {
    pageNumber() {
      return this.paginationIndex + 1;
    },
    hasPrev() {
      return this.paginationIndex > 0;
    },
  },

  methods: {
    print() {
      window.print();
    },

    traducirEstadoCuenta(val) {
      let estadoCuenta = [
        { value: 1, name: "RECHAZADA" },
        { value: 2, name: "VALIDADA" },
        { value: 3, name: "PDTE. VALIDACIÓN" },
        { value: 4, name: "RECHAZADA POR DOCUMENTACION" },
        { value: 5, name: "PDTE. VALIDACIÓN" },
        { value: 6, name: "PDTE. DOCUMENTACION " },
      ];

      return estadoCuenta.find((x) => x.value == val).name;
    },
    downloadExcel() {
      let data = [
        {
          sheet: this.$t("accounts.accountNumbers"),
          columns: [
            { label: "Cuenta", value: "iban" },
            { label: "BIC", value: "bic" },
            { label: "Descripción", value: "description" },
            {
              label: "Estado de Cuenta",
              value: (v) => this.traducirEstadoCuenta(v.codEcvEgc),
            },
          ],
          content: this.accountsList,
        },
      ];
      let settings = { fileName: this.$t("accounts.accountNumbers") };
      xlsx(data, settings);
    },
    editItem(item) {
      this.editDialog = !this.editDialog;
      let copy = Object.assign({}, item);
      this.currentAccount = copy;
    },

    editAcconut(item) {
      if (
        item.codEcvEgc === "3" ||
        item.codEcvEgc === "5" ||
        item.codEcvEgc === "2"
      ) {
        this.editDialog = !this.editDialog;
        let copy = Object.assign({}, item);
        this.currentAccount = copy;
      } else {
        this.spinner = true;
        sessionStorage.setItem("vec", JSON.stringify(item));
        this.spinner = false;
        this.$router.push({ path: "/cuentas-de-abono/account-edit" });
      }
    },
    goToAddAccount() {
      sessionStorage.removeItem("accountConfirm");
      this.$router.push("/cuentas-de-abono/alta");
    },

    deleteItem(item) {
      this.deleteDialog = !this.deleteDialog;
      this.currentAccount = item;
    },
    async goToPageOne() {
      this.paginationIndex = 1;
      await this.prevPage();
    },
    async nextPage() {
      this.query.paginationItem = this.pageIndexItems[this.paginationIndex++];
      await this.get_list_account();
    },
    async prevPage() {
      this.paginationIndex--;
      if (this.paginationIndex > 0) {
        this.query.paginationItem =
          this.pageIndexItems[this.paginationIndex - 1];
      } else {
        delete this.query.paginationItem;
      }
      await this.get_list_account();
    },
    async resetPaginationAndSearch() {
      delete this.query.paginationItem;
      this.paginationIndex = 0;
      this.pageIndexItems = [];
      await this.get_list_account();
    },
    async confirmDelete() {
      await this.get_list_account();
      this.deleteDialog = !this.deleteDialog;
    },
    async get_list_account() {
      this.accountsList = [];
      const qs = Object.keys(this.query)
        .filter(key => this.query[key])
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(this.query[key])}`
        )
        .join("&");
      try {
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;
        this.accounts = await Api.get(
          `/proveedores/${this.userId}/cuentas-abono/?${qs}`
        );
        this.accountsList =
          this.accounts.data.response.subscriptionAccountResponseList;
        this.itemsPerPage = this.accountsList.length;
        this.hasNext = this.accounts.data.response.moreData == 1;
        if (
          !this.pageIndexItems.includes(
            this.accounts.data.response.paginationItem
          )
        ) {
          this.pageIndexItems.push(this.accounts.data.response.paginationItem);
        }
        this.spinner = false;
        this.noData = false;
      } catch (error) {
        this.valCode = error.response.data.code;
        this.noData = true;
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
